export default {
  data() {
    return {
      info: this.$services.resolve('info'),
      subscriber: this.$services.resolve('subscriber'),
    };
  },
  computed: {
    tenantName() {
      return this.subscriber.currentTenant.replace(/_[^_]*$/, '');
    },
    tenantLogoSrc() {
      return this.info.logoLocation;
    },
    tenantLogoInverse() {
      return `${this.info.resourcesUrl}/logos/${this.tenantName}-inverse.png`;
    },
    tenantLogoAlt() {
      return this.$t('seo.logo', { tenant: this.tenantName });
    },
  },
};
